(async function () {
  console.log('gift-guard loaded');

  const MAIN_HANDLE = 'trackeo-magnettag';
  const GIFT_HANDLE = 'trackeo-gift';

  let isProcessing = false;
  let lastSeenSignature = '';
  let lastSeenAt = 0;
  const STABLE_MS = 1200; // זמן המתנה עד שהעגלה "מתייצבת"

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  async function changeLine(line, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity })
    });
  }

  async function enforceGiftLimit() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart = await getCart();
      const items = cart.items || [];

      const signature = items.map(i => `${i.handle}:${i.quantity}`).join('|');
      const now = Date.now();

      // אם העגלה השתנתה עכשיו - רק נרשום ונחכה שתתייצב
      if (signature !== lastSeenSignature) {
        lastSeenSignature = signature;
        lastSeenAt = now;
        isProcessing = false;
        return;
      }

      // אם לא עבר מספיק זמן מאז השינוי האחרון - עדיין לא לאכוף
      if (now - lastSeenAt < STABLE_MS) {
        isProcessing = false;
        return;
      }

      const mainItems = items.filter(i => i.handle === MAIN_HANDLE);
      const giftItems = items
        .map((item, idx) => ({ ...item, line: idx + 1 }))
        .filter(i => i.handle === GIFT_HANDLE);

      const mainQty = mainItems.reduce((sum, i) => sum + i.quantity, 0);
      const giftQty = giftItems.reduce((sum, i) => sum + i.quantity, 0);

      // אין מוצר ראשי -> אין מתנה בכלל
      if (mainQty === 0 && giftQty > 0) {
        console.log('Removing all gifts because no main product exists');
        for (const item of [...giftItems].reverse()) {
          await changeLine(item.line, 0);
        }

        lastSeenSignature = '';
        lastSeenAt = Date.now();

        if (window.location.pathname === '/cart') {
          window.location.reload();
          return;
        }

        isProcessing = false;
        return;
      }

      // יש יותר מתנות ממוצרים ראשיים -> לקצץ רק לעודף
      if (giftQty > mainQty) {
        let excess = giftQty - mainQty;
        console.log(`Reducing gift quantity. mainQty=${mainQty}, giftQty=${giftQty}, excess=${excess}`);

        for (const item of [...giftItems].reverse()) {
          if (excess <= 0) break;

          const removable = Math.min(item.quantity, excess);
          const newQty = item.quantity - removable;
          excess -= removable;

          await changeLine(item.line, newQty);
        }

        lastSeenSignature = '';
        lastSeenAt = Date.now();

        if (window.location.pathname === '/cart') {
          window.location.reload();
          return;
        }
      }
    } catch (e) {
      console.warn('gift-guard error', e);
    }

    isProcessing = false;
  }

  enforceGiftLimit();
  setInterval(enforceGiftLimit, 500);
})();